<template>
  <div>
    <a-card :title="title">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 220px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="名称/别名/描述/关键词" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="max-width: 140px; margin-bottom: 12px;">
          <a-select v-model="searchForm.crop" allowClear placeholder="作物" style="width: 100%" @change="search">
            <a-select-option v-for="o in cropOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
        <div style="margin-bottom: 12px; float: right;">
          <a-button type="primary" icon="plus" style="margin: 0 8px;" @click="openFormModal({})">新增</a-button>
        </div>
      </a-row>
      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading" :pagination="pagination"
          @change="tableChange">
          <div slot="cover" slot-scope="value, item">
            <img v-if="item.cover_url || (item.image_urls && item.image_urls[0])" :src="item.cover_url || item.image_urls[0]"
              style="width:48px;height:48px;object-fit:cover;border-radius:4px;" />
            <span v-else>-</span>
          </div>
          <div slot="crops" slot-scope="value">
            <a-tag v-for="t in (value || [])" :key="t" color="green">{{ t }}</a-tag>
          </div>
          <div slot="is_active" slot-scope="value">
            <a-tag :color="value ? 'green' : 'red'">{{ value ? '启用' : '停用' }}</a-tag>
          </div>
          <div slot="action" slot-scope="value, item">
            <a-button-group>
              <a-button icon="edit" size="small" @click="openFormModal(item)">编辑</a-button>
              <a-popconfirm title="确定删除吗" @confirm="destroy(item.id)">
                <a-button type="danger" icon="delete" size="small">删除</a-button>
              </a-popconfirm>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
    <form-modal
      v-model="visible"
      :form="targetItem"
      :cropOptions="cropOptions"
      :pesticideOptions="pesticideOptions"
      :api="api"
      :kindLabel="kindLabel"
      @create="list"
      @update="list"
    />
  </div>
</template>

<script>
import { pesticideList } from '@/api/plantProtect'

export default {
  name: 'HandbookList',
  components: {
    FormModal: () => import('./FormModal.vue'),
  },
  props: {
    title: { type: String, required: true },
    kindLabel: { type: String, required: true },
    api: { type: Object, required: true },
  },
  data() {
    return {
      columns: [
        { title: '序号', dataIndex: 'index', customRender: (v, i, index) => index + 1, width: 50 },
        { title: '图片', dataIndex: 'cover_url', scopedSlots: { customRender: 'cover' }, width: 70 },
        { title: '名称', dataIndex: 'name' },
        { title: '别名', dataIndex: 'alias', width: 120 },
        { title: '作物', dataIndex: 'crops_display', scopedSlots: { customRender: 'crops' }, width: 160 },
        { title: '危害', dataIndex: 'harm', ellipsis: true },
        { title: '状态', dataIndex: 'is_active', scopedSlots: { customRender: 'is_active' }, width: 70 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 156 },
      ],
      searchForm: { search: '', crop: undefined, page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      visible: false,
      targetItem: {},
      cropOptions: [],
      pesticideOptions: [],
    }
  },
  methods: {
    initialize() {
      this.api.meta().then(data => {
        this.cropOptions = data.crops || []
      }).catch(() => {})
      pesticideList({ page_size: 200, is_active: true }).then(data => {
        this.pesticideOptions = (data.results || []).map(p => ({
          value: p.id,
          label: `${p.name}${p.common_name ? '（' + p.common_name + '）' : ''}`,
        }))
      }).catch(() => {})
      this.list()
    },
    list() {
      this.loading = true
      this.api.list(this.searchForm).then(data => {
        this.pagination.total = data.count
        this.items = data.results
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.searchForm.page = 1
      this.pagination.current = 1
      this.list()
    },
    tableChange(pagination) {
      this.pagination = pagination
      this.searchForm.page = pagination.current
      this.searchForm.page_size = pagination.pageSize
      this.list()
    },
    openFormModal(item) {
      this.targetItem = item && item.id ? { ...item, recommended_pesticides: (item.recommended_pesticides || []) } : {
        crops: ['wheat'],
        keywords: [],
        image_urls: [],
        recommended_pesticides: [],
        is_active: true,
      }
      this.visible = true
    },
    destroy(id) {
      this.api.destroy({ id }).then(() => {
        this.$message.success('删除成功')
        this.list()
      })
    },
  },
  mounted() {
    this.initialize()
  },
}
</script>
